'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var handleResponse = function handleResponse(response, endpointUrl) {
  if (response.ok) {
    if (201 === response.status) {
      return response.headers.get('Location') || endpointUrl;
    } else if (204 === response.status) {
      return true;
    } else {
      return response.json();
    }
  } else {
    return Promise.reject(response.status);
  }
};

var fetchResponse = function fetchResponse(endpointUrl, configuration, maxTries) {
  return fetch(endpointUrl, configuration).then(function (response) {
    if (503 === response.status || 504 === response.status) {
      return Promise.reject('retry');
    } else {
      return handleResponse(response, endpointUrl);
    }
  })["catch"](function (error) {
    if ('retry' === error && 0 !== maxTries) {
      return fetchResponse(endpointUrl, configuration, maxTries - 1);
    } else {
      return Promise.reject(error);
    }
  });
};

var constructUrl = function constructUrl(useApiGateway, url) {
  if (useApiGateway && !url.startsWith('http')) {
    return "".concat(getApiGateway()).concat(url);
  } else {
    return url;
  }
};

var getApiGateway = function getApiGateway() {
  if (window._env_ && window._env_.REACT_APP_API_GATEWAY) {
    return window._env_.REACT_APP_API_GATEWAY;
  } else {
    return process.env.REACT_APP_API_GATEWAY;
  }
};

var kitFetchFactory = function kitFetchFactory(_ref) {
  var _ref$useApiGateway = _ref.useApiGateway,
      useApiGateway = _ref$useApiGateway === void 0 ? false : _ref$useApiGateway,
      _ref$jsonType = _ref.jsonType,
      jsonType = _ref$jsonType === void 0 ? true : _ref$jsonType;
  return function (url) {
    var configuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var token = localStorage.getItem('kit.access_token');
    var headers = new Headers({
      'Authorization': "Bearer ".concat(token),
      'Correlation-Id': v4()
    });

    if (jsonType) {
      headers.append('Content-Type', 'application/json');
    }

    var newConfiguration = _objectSpread2({
      headers: headers
    }, configuration);

    var endpointUrl = constructUrl(useApiGateway, url);

    if (jsonType) {
      return fetchResponse(endpointUrl, newConfiguration, 3);
    } else {
      return fetch(endpointUrl, newConfiguration);
    }
  };
};
/**
 * Attaches Authorization header and fetches an api outside the apigateway.
 * @type {function(*, *=): Promise<Response>}
 */


var kitFetchExternal = kitFetchFactory({});
/**
 * Attaches Authorization header and fetches api through api gateway.
 * Api gateway must be defined in process.env.REACT_APP_API_GATEWAY or window._env_.REACT_APP_API_GATEWAY.
 * Example: kitFetch('/museum-api/museums')
 * @type {function(*, *=): Promise<Response>}
 */

var kitFetch = kitFetchFactory({
  useApiGateway: true
});
/**
 * Attaches Authorization header and fetches api through api gateway.
 * Api gateway must be defined in process.env.REACT_APP_API_GATEWAY or window._env_.REACT_APP_API_GATEWAY.
 * Doesn't set Content-Type.
 * @type {function(*, *=): Promise<Response>}
 */

var kitFileUpload = kitFetchFactory({
  useApiGateway: true,
  jsonType: false
});
/**
 * Attaches Authorization header and fetches api without using the api gateway.
 * Doesn't set Content-Type.
 * @type {function(*, *=): Promise<Response>}
 */

var kitFileUploadExternal = kitFetchFactory({
  useApiGateway: false,
  jsonType: false
});
var kitGetBlob = kitFileUpload;

exports.kitFetch = kitFetch;
exports.kitFetchExternal = kitFetchExternal;
exports.kitFileUpload = kitFileUpload;
exports.kitFileUploadExternal = kitFileUploadExternal;
exports.kitGetBlob = kitGetBlob;
//# sourceMappingURL=index.js.map
